import * as React from 'react';
import { Grid } from '@material-ui/core';
import TextField from '../../../../ui-components/TextField/TextField';
import Button from '../../../../ui-components/Button/Button';
import NewItemButton from '../../../../ui-components/Button/NewItemButton';
import SearchButton from '../../../../ui-components/Button/SearchButton';
import AddTagDialog from '../AddTagDialog';
import { tag } from '../../../../model/tag';

interface IProps {
    loadTags: (key: string) => void;
    addTag: (tag: tag) => void;
    classes: any;
    smallScreen: boolean;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (props: IProps) => {
    const [tag, setTag] = React.useState('');
    const [open, setOpen] = React.useState(false);
    return (
        <Grid container className={props.classes.SearchContainer}>
            <Grid item sm={8} xs={10} className={props.classes.SearchSection}>
                <TextField
                    label="Tag"
                    value={tag}
                    onKeyDown={(e) => {
                        //Enter KeyCode = 13
                        if (e.keyCode === 13) {
                            props.loadTags(tag)
                        }
                    }}
                    onChange={setTag}
                    onBlur={null}
                />
            </Grid>
            {!props.smallScreen &&
                <Grid item sm={4} className={props.classes.searchButtons}>
                    <div className={props.classes.searchButton}>
                        <Button onClick={() => props.loadTags(tag)}>Cerca</Button>
                    </div>
                    <div className={props.classes.searchButton}>
                        <NewItemButton onClick={() => { setOpen(true) }} text='Nuova' />
                    </div>
                </Grid>
            }
            {props.smallScreen && <>
                <Grid item xs={2} className={props.classes.searchButtons}>
                    <div className={props.classes.searchButton}>
                        <SearchButton onClick={() => props.loadTags(tag)} />
                    </div>
                </Grid>
                <Grid sm={12}>
                    <div className={props.classes.searchButton}>
                        <NewItemButton onClick={() => { setOpen(true) }} text='Nuova' />
                    </div>
                </Grid>

            </>
            }
            <AddTagDialog
                onConfirm={(tag) => { props.addTag(tag); setOpen(false) }}
                onCancel={() => setOpen(false)}
                open={open} />
        </Grid>
    );
}